import mixpanel from 'mixpanel-browser';

const mixpanelToken = import.meta.env.VITE_MIXPANEL_TOKEN;

const debug = !import.meta.env.PROD;
let initialized = false;

function init() {
	if (!mixpanelToken) {
		debug && console.error('Tracking', 'VITE_MIXPANEL_TOKEN was not defined');
		return;
	}
	mixpanel.init(mixpanelToken, { debug, api_host: 'https://mp.locumbase.com' });
	initialized = true;
}

function track(label, dict = {}) {
	if (!initialized) {
		debug && console.error('Tracking', 'Not initialized', { label, dict });
		return;
	}
	mixpanel.track(label, dict);
}

function setUser(id, email, firstName, lastName, type, tenant, industry) {
	try {
		mixpanel.identify(id);
		mixpanel.people.set({
			id,
			email,
			firstName,
			lastName,
			type,
			tenant,
			industry,
		});
	} catch (e) {
		console.error(e);
	}
}

function updateMixpanel(email, firstname, lastname, type, industry, tenant) {
	try {
		mixpanel.people.set({
			email,
			firstname,
			lastname,
			type,
			industry,
			tenant,
		});
	} catch (e) {
		console.error(e);
	}
}

export const Tracking = {
	init,
	track,
	setUser,
	updateMixpanel,
};
